// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	<div style="overflow: auto; width:300px; height:200px;">
text here....
</div>

});